import { useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { makeApi } from "@/lib/api";

// Carrier's own Load #. Blank = auto-assign; duplicates warn but are allowed.
const SAFE = /^[A-Za-z0-9 _\-/.#]*$/;

export const CarrierNumberField = ({ id, value, onChange, excludeId, testId = "carrier-number", inputClass = "mt-1.5" }) => {
  const { getToken } = useAuth();
  const [info, setInfo] = useState({ next: "", clash: null });

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const { data } = await makeApi(getToken).get("/loads/carrier-number", { params: { number: value || undefined, exclude: excludeId || undefined } });
        setInfo(data);
      } catch { /* warning is best-effort */ }
    }, 350);
    return () => clearTimeout(t);
  }, [value, excludeId, getToken]);

  const c = value?.trim() && info.clash;
  return (
    <div>
      <Label htmlFor={id}>Load #</Label>
      <Input id={id} className={`${inputClass} ${SAFE.test(value || "") ? "" : "border-rose-400"}`} value={value || ""} maxLength={60} onChange={(e) => onChange(e.target.value)}
        placeholder={info.next ? `Auto: ${info.next}` : "Auto"} data-testid={`${testId}-input`} />
      {!SAFE.test(value || "") ? (
        <p className="mt-1 text-xs text-rose-600" data-testid={`${testId}-format-error`}>Use letters, numbers, spaces and - _ / . # only.</p>
      ) : c ? (
        <p className="mt-1 text-xs text-amber-700 flex items-start gap-1" data-testid={`${testId}-duplicate-warning`}>
          <AlertTriangle className="w-3.5 h-3.5 mt-px shrink-0" />
          Load #{value.trim()} is already used by the load with broker ref #{c.load_number}{c.in_trash ? " (in Trash)" : ""}. You can still save.
        </p>
      ) : (
        <p className="mt-1 text-xs text-slate-500">Your own number for this load. {excludeId ? "" : "Leave blank to use the next one."}</p>
      )}
    </div>
  );
};
